import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';

export default function Celebration({ onClose }) {
  // Precompute random properties so they don't shift endlessly across the screen
  const particles = React.useMemo(() => [...Array(40)].map(() => ({
    left: `${Math.random() * 100}%`,
    drift: (Math.random() > 0.5 ? 1 : -1) * (Math.random() * 20 + 10),
    delay: Math.random() * 3,
    duration: Math.random() * 3 + 2,
    size: Math.random() * 20 + 15,
    isHeart: Math.random() > 0.5
  })), []);

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center pointer-events-none overflow-hidden" onClick={onClose}>
      {particles.map((p, i) => (
        <motion.div 
          key={i} 
          className="absolute drop-shadow-lg pointer-events-none" 
          initial={{ top: -50, x: 0, left: p.left, rotate: 0, opacity: 1 }} 
          animate={{ top: "110vh", rotate: 360, x: [0, p.drift, -p.drift, 0] }} 
          transition={{ duration: p.duration, repeat: Infinity, delay: p.delay, ease: "linear" }}
        >
          {p.isHeart ? <Heart fill="#f43f5e" color="#f43f5e" size={p.size} /> : <div className="bg-yellow-400 rounded-sm" style={{ width: p.size - 5, height: p.size - 5 }} />}
        </motion.div>
      ))}
    </div>
  );
}
